import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
export const StyledModalHeader = styled.div`
    display: flex;
    ${mixins.setFontVariant("h5_2", colorsPalettes.carbon["400"])};
    margin-bottom: 19px;
`;

export const StyledModalDescription = styled.div`
    display: inline;
    margin: 16px 0 24px 0;
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    button:first-child {
        margin-right: 8px;
    }
`;
